import React from 'react';
import { useTranslate } from '@tolgee/react';

interface LomavisDataProcessingPlaceholderProps {
  /** The height of the placeholder container */
  height?: string;
  /** The message to display */
  message?: string;
}

/**
 * Atoms: LomavisDataProcessingPlaceholder
 * A placeholder component that displays a message when data is still being processed
 */
export const LomavisDataProcessingPlaceholder: React.FC<
  LomavisDataProcessingPlaceholderProps
> = ({ height = '400px', message }) => {
  const { t } = useTranslate();
  const defaultMessage = t('placeholders.dataProcessing.defaultMessage');
  return (
    <div
      style={{
        height,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        textAlign: 'center',
        fontSize: '1.2rem',
        color: '#666'
      }}
    >
      <i
        className="fa-duotone fa-solid fa-gear"
        style={{ fontSize: '2rem', marginBottom: '1rem' }}
      ></i>
      {message || defaultMessage}
    </div>
  );
};
